<template>
  <div>
    <section class="contact-us-section" id="contact-us-section">
      <div class="container py-5">
        <h2 class="main-heading-1-gradient text-center">
          Book Your Free Appointment
        </h2>

        <div class="row justify-content-center mt-5">
          <div class="col-lg-6">
            <img src="@/assets/imgs/contact-us.svg" class="img-fluid" />
          </div>
          <div class="col-lg-6">
            <!-- <form action="https://formsubmit.co/info@aliff.in" method="POST"> -->
            <form @submit.prevent="handleSubmit">
              <h3 class="main-content-1-gradient">
                Get all your queries answered along with a Personalized Career
                Map
              </h3>
              <div class="custom-form-control mt-5">
                <div class="form-spacing text-left">
                  <label>Name:</label>  
                  <input
                    v-model="formData.name"
                    name="Name"
                    id="name_id"
                    type="text"
                    class="form-control"
                    placeholder="Enter your name"
                    required
                  />
                </div>
                <div class="form-spacing text-left">
                  <label>Email:</label>
                  <input
                    v-model="formData.email"
                    name="Email"
                    id="email_id"
                    type="email"
                    class="form-control"
                    placeholder="Enter your email"
                  />
                </div>
                <div class="form-spacing text-left">
                  <label>Phone:</label>
                  <input
                    v-model="formData.phone"
                    name="Phone"
                    id="phone_id"
                    type="tel"
                    class="form-control"
                    placeholder="Enter your phone number"
                  />
                </div>
                <div class="form-spacing text-left">
                  <label>Message:</label>
                  <input
                    v-model="formData.message"
                    name="Message"
                    id="message_id"
                    type="text"
                    class="form-control"
                    placeholder="Enter your Message"
                  />
                </div>
              </div>
              <div class="mt-5">
                <!-- <button class="btn-secondary-red">Send Message</button> -->
                <input
                  type="submit"
                  value="Book your Exploratory Call Now!"
                  class="btn-secondary-red-2"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { BModal } from "bootstrap-vue";
// import Calendly from "vue-calendly";
// import "https://assets.calendly.com/assets/external/widget.js"
import axios from "axios";
import { LMS_API } from "@/config/index";

export default {
  name: "ContactusSection",
  props: {
    source: {
      type: Number, 
      default: 0,
    }
  },
  data() {
    console.log("in data");
    return {
      value: "value",
      formData: {
        name: "",
        email: "",
        phone: "",
        message: "",
      },
    };
  },
  components: {
    BModal,
  },
 
  methods: {
    async bookFreeCounselling() {
      window.open("https://calendly.com/info-aliff-39025");
    },
    formSubmitToast() {
      this.$bvToast.toast(`The form has been submitted successfully.`, {
        title: "Form Submitted",
        autoHideDelay: 5000,
        solid: true,
      });
    },
   
    resetForm() {
      this.formData = {
        name: "",
        email: "",
        phone: "",
        message: "",
      };
    },
    async handleSubmit(e) {
      try {
        e.preventDefault();
        


        const requestData = {
          full_name: this.formData.name,
          email: this.formData.email,
          mobile: this.formData.phone,
          message: this.formData.message,
          ls_id: this.source,
          m_id: 1,
        };
        console.log(requestData);
        const response = await axios.post(
          `${LMS_API}/form-webhook/lead`,
          requestData
        );
        if (response.data.status) {
          this.formSubmitToast();
          this.resetForm();
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
.btn-secondary-red-2 {
  width: 100%; /* Make the button occupy the full width of its container */
  max-width: 300px; /* Set a maximum width for the button */
  padding: 9px;
  font-size: 15px;
  background: linear-gradient(90deg, #ff7a00 0%, #ff3d00 100%);
  border-radius: 4px;
  /* padding: 0.5rem 3rem; */
  color: #fff;
  text-transform: capitalize;
  text-decoration: none;
  border: none;
  box-shadow: 0 10px 20px #286fdb4d;
  max-width: fit-content;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/ContactusSection.vue